import { Link } from 'react-router-dom';
import { Heart } from 'lucide-react';

function HealthcareFacilities() {
  return (
    <div className="pt-28">
      {/* Hero Section with Background Image */}
      <section className="relative h-96 flex items-center justify-center overflow-hidden">
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: 'url(https://images.pexels.com/photos/263402/pexels-photo-263402.jpeg?auto=compress&cs=tinysrgb&fit=crop&w=1920)' }}
        ></div>
        <div className="absolute inset-0 bg-black/60"></div>
        <div className="absolute inset-0 brass-lighting"></div>
        <div className="absolute inset-0 geometric-brass"></div>
        <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl md:text-6xl font-bold text-white mb-4 font-serif" style={{ fontFamily: 'Playfair Display, Georgia, serif' }}>
            Healthcare <span className="text-gold">Facilities</span>
          </h1>
          <p className="text-xl text-gray-200 max-w-3xl mx-auto">
            Specialized construction for medical facilities and healthcare infrastructure
          </p>
        </div>
      </section>

      <section className="bg-black py-32 relative overflow-hidden border-t border-gold/30">
        <div className="absolute inset-0 brass-lighting"></div>
        <div className="absolute inset-0 geometric-brass"></div>
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-gray-300 space-y-6 text-lg leading-relaxed">
            <p>
              Williams Diversified brings specialized expertise to healthcare facility construction and support services. We understand the unique requirements of medical environments, from strict infection control protocols to specialized mechanical systems, and we deliver projects that meet the highest healthcare standards.
            </p>
            <p>
              Our healthcare services span both public sector projects—including VA hospitals, military medical facilities, and government health centers—and private sector work for hospitals, outpatient clinics, urgent care centers, and specialized medical facilities. We maintain certifications and experience necessary for healthcare construction compliance.
            </p>
            
            <h3 className="text-3xl font-bold text-white mt-12 mb-6 font-serif" style={{ fontFamily: 'Playfair Display, Georgia, serif' }}>Healthcare Construction Services</h3>
            <ul className="space-y-4">
              <li className="flex items-start"><span className="text-gold mr-3">•</span><span>Hospital and medical center construction</span></li>
              <li className="flex items-start"><span className="text-gold mr-3">•</span><span>Outpatient clinic and urgent care facilities</span></li>
              <li className="flex items-start"><span className="text-gold mr-3">•</span><span>VA and military medical facilities</span></li>
              <li className="flex items-start"><span className="text-gold mr-3">•</span><span>Medical office buildings and specialty centers</span></li>
              <li className="flex items-start"><span className="text-gold mr-3">•</span><span>Laboratory and research facilities</span></li>
              <li className="flex items-start"><span className="text-gold mr-3">•</span><span>Emergency department expansions and renovations</span></li>
            </ul>

            <h3 className="text-3xl font-bold text-white mt-12 mb-6 font-serif" style={{ fontFamily: 'Playfair Display, Georgia, serif' }}>Specialized Healthcare Services</h3>
            <ul className="space-y-4">
              <li className="flex items-start"><span className="text-gold mr-3">•</span><span>Medical gas systems and specialized HVAC</span></li>
              <li className="flex items-start"><span className="text-gold mr-3">•</span><span>Infection control and clean room construction</span></li>
              <li className="flex items-start"><span className="text-gold mr-3">•</span><span>Radiology and imaging suite installation</span></li>
              <li className="flex items-start"><span className="text-gold mr-3">•</span><span>Operating room and surgical suite construction</span></li>
              <li className="flex items-start"><span className="text-gold mr-3">•</span><span>Healthcare facility renovations and expansions</span></li>
              <li className="flex items-start"><span className="text-gold mr-3">•</span><span>Compliance with Joint Commission and healthcare codes</span></li>
            </ul>

            <div className="bg-black border border-gold/30 rounded-lg p-8 mt-12">
              <h4 className="text-2xl font-bold text-gold mb-4">Healthcare Compliance Expertise</h4>
              <p className="text-gray-300 leading-relaxed">
                We maintain deep knowledge of healthcare building codes, infection control protocols, and regulatory requirements. Our team is experienced in working within occupied healthcare facilities, understanding the critical nature of maintaining patient care during construction activities.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="bg-black py-24 relative overflow-hidden border-t border-gold/30">
        <div className="absolute inset-0 brass-lighting"></div>
        <div className="absolute inset-0 geometric-brass"></div>
        <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center relative z-10">
          <h3 className="text-4xl md:text-5xl font-bold text-white mb-6 font-serif" style={{ fontFamily: 'Playfair Display, Georgia, serif' }}>
            Build Better <span className="text-gold">Healthcare Facilities</span>
          </h3>
          <p className="text-gray-300 text-xl mb-10">
            Partner with experts who understand healthcare construction requirements
          </p>
          <Link to="/contact" className="inline-block bg-gold hover:bg-gold-dark text-black font-bold py-5 px-12 rounded text-lg transition-all transform hover:scale-105 uppercase tracking-wider">Contact Us</Link>
        </div>
      </section>
    </div>
  );
}

export default HealthcareFacilities;
